import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HashRouter} from "react-router-dom";
import {createMemoryHistory} from "history";

const history = createMemoryHistory();
const root = ReactDOM.createRoot(document.getElementById('limmud-donations-form'));
root.render(
    <React.StrictMode>
        <HashRouter location={history.location} navigator={history}>
            <App />
        </HashRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
